import React, { useState } from "react";
import { BLACK_COLOR } from "../../resources/colorsManager";
import DatePickerNew from "./DatePicker";
function CustomDatePicker({
  onChangeDate,
  title,
  datePlaceholder = "",
  style,
  minDate = "",
  fontStyles,
}) {
  return (
    <>
      {title && (
        <p
          style={{
            fontSize: 12,
            color: BLACK_COLOR,
            padding: 0,
            margin: 0,
          }}
        >
          {title}
        </p>
      )}

      <DatePickerNew
        onChangeData={(val) => {
          onChangeDate(val);
        }}
        style={style}
        datePlaceholder={datePlaceholder}
        minDate={minDate}
        fontStyles={fontStyles}
      />
    </>
  );
}

export default CustomDatePicker;
